import { useState } from 'react';
import { Modal } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import './FooterStyles.css';
import logo from '../../assets/its-logo.png';
import { FaPhone } from 'react-icons/fa';
import { ImTree } from 'react-icons/im';

const Footer = () => {
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = () => {
		setShowModal(true);
	};

	return (
		<footer>
			<div class="footer-left">
				<p>Powered By:</p>
				<a class="footer-logo" href="http://www.its-na.com/">
					<img src={logo} alt="logo" />
				</a>
			</div>

			<div class="footer-right">
				<button href="" class="plain-button">
					<a href="/smart-inspect/warren/site-map">
						<ImTree style={{ margin: '5px', color: '#000' }} />
					</a>
				</button>
				<button href="" class="plain-button" target="_self" onClick={handleShowModal}>
					<FaPhone style={{ margin: '5px' }} />
					<span class="plain-button-copy">
						<b>Contact Us</b>
					</span>
				</button>
			</div>

			<Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="course-modal" centered>
				<Modal.Header closeButton>
					<Modal.Title>CONTACT</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div class="modal-window">
						<div id="contact">
							<div class="contactdiv">
								<div class="contactgroup">
									<h2>Interactive Training Systems Inc.</h2>
									<p>
										118 S Leroy St.
										<br />
										Fenton, MI 48430
									</p>
									<p>
										<a href="tel:18107147630">(810) 714-7630</a>
									</p>
								</div>
								<div class="contactgroup">
									<h2>Doug Maguffee - President</h2>
									<p>
										<a href="mailto:dmaguffee@its-na.com">dmaguffee@its-na.com</a>
									</p>
								</div>
								<div class="contactgroup">
									<h2>Amy Seymour - Director of Operations</h2>
									<p>
										<a href="mailto:aseymour@its-na.com">aseymour@its-na.com</a>
									</p>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</footer>
	);
};
export default Footer;
